module.exports = __webpack_public_path__ + "img/alka_seltzer_heartburn_relief_effervescent_tablets_extra_strength.6a68325b.jpg";